import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";
import { z } from "zod";
export const BorderRadiusUnit = z.enum(["Pixels", "Rem", "Percent"]);
export const BorderRadiusValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const BorderRadiusTokenData = tokenAliasOrValue(BorderRadiusValue);
